import { ToolCategory } from './tool-category';
import { User } from './user';

export class HistoricalMovement {

  constructor(
    public hash?: string,
    public toolName?: string,
    public toolErpName?: string,
    public isHolder?: boolean,
    public rebuildToolName?: string,
    public rebuildToolErpName?: string,
    public date?: number,
    public quantity?: number,
    public sent?: boolean,
    public type?: string,
    public toolCategory?: ToolCategory,
    public user?: User
  ) { }

  get userName() {
    return this.user ? this.user.fullName : null;
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/historical-movement.ts